<script lang="ts" setup>
import type { IProps } from './ContactBox.types'

defineProps<IProps>()
</script>

<template>
  <article class="contact-box">
    <img
      class="contact-box__icon"
      :src="icon"
      width="48"
      height="48"
      aria-hidden="true"
    >

    <h3 class="contact-box__title">
      {{ title }}
    </h3>

    <UiButton
      class="contact-box__button"
      variant="secondary"
      size="small"
      :to="button.to"
      :target="button.target"
    >
      {{ button.text }}

      <img
        src="/icons/icn_arrow_right.svg"
        aria-hidden="true"
      >
    </UiButton>
  </article>
</template>

<style lang="scss" scoped>
.contact-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  padding: 3.2rem;
  background-color: $white;
  border: 1px solid $gray-300;
  border-radius: 1.6rem;

  &__icon {
    margin-bottom: 2.4rem;
    object-fit: contain;
  }

  &__title {
    @include h10;
    margin-bottom: 2.4rem;
    color: $text-400;
  }

  &__button {
    gap: 0.8rem;
    margin-top: auto;
  }
}
</style>
